import { Injectable } from '@angular/core';
import { WindowWrapperService } from 'app/modules/main/services/window-wrapper.service';

@Injectable({ providedIn: 'root' })
export class WindowService {

  constructor(
    private readonly windowWrapper: WindowWrapperService,
  ) {
  }

  get locationPathSegments(): string[] {

    return this.windowWrapper.pathname
      .replace(/^\//, '')
      .split('/');
  }

  get locationUri(): string {
    return this.windowWrapper.href.replace(this.windowWrapper.origin, '');
  }

  public redirectTo(
    url: string
  ) {
    this.windowWrapper.href = url;
  }

  public redirectToErrorPage() {
    this.redirectTo(`${this.windowWrapper.origin}/error`);
  }

  public redirectToLoginPage() {
    this.redirectTo(`${this.windowWrapper.origin}/login`);
  }

  public redirectToUnauthorizedPage() {
    this.redirectTo(`${this.windowWrapper.origin}/error/unauthorized`);
  }

}
